exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row_title[data-v-2046c57d]{width:246px}.demo-drawer__content[data-v-2046c57d]{padding:0 30px}.title[data-v-2046c57d]{margin-bottom:14px;color:#303133;font-weight:500;font-size:14px}.description-term[data-v-2046c57d]{display:table-cell;padding-bottom:5px;line-height:20px;width:50%;font-size:12px;color:#606266}.description[data-v-2046c57d]  .el-divider--horizontal{margin:12px 0 !important}", ""]);

// exports
